import { defineStore } from "pinia";
import {
  getPaintingGenerationList,
  getPaintingStyleList,
} from "./styleData/style";

const BaseUrl =
  "https://anymate-us.oss-us-west-1.aliyuncs.com/common/md_checkpoint_style/cover/";

export const useGenStyle = defineStore("genStyle", {
  state: () => ({
    styleList: new Array(25).fill(0).map((_, i) => {
      return {
        id: i + 1,
        coverImage: `${BaseUrl}${i + 1}.png`,
      };
    }),
    customStyleList: getPaintingStyleList(),
    generationStyleList: getPaintingGenerationList(),
  }),
  actions: {
    getRandStyle() {
      const randIndex = Math.floor(Math.random() * this.styleList.length);
      return this.styleList[randIndex];
    },
    getStyleUrlById(id: number) {
      return `${BaseUrl}${id}.png`;
    },
  },
});
